import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CustomStars from "../../../../../../components/customStars/CustomStars";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import {
  selectEndDate,
  selectIniDate,
} from "../../../../../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import { ActiveHotelI } from "../../Mapview";
import styles from "./MiniCard.module.scss";
import parse from "html-react-parser";

interface PropsI {
  lat: string | undefined;
  lng: string | undefined;
  hotel: ActiveHotelI;
  miniCardEl: React.RefObject<HTMLDivElement>;
}

const MiniCard: React.FC<PropsI> = (props) => {
  const { hotel, miniCardEl } = props;

  const iniDate = useAppSelector(selectIniDate);
  const endDate = useAppSelector(selectEndDate);

  const { t } = useTranslation();

  const hotelId = useRef(hotel.id);

  return (
    <div ref={miniCardEl} className={styles.miniCard}>
      <Link
        to={`${document.location.pathname}?&iniDate=${iniDate}&endDate=${endDate}&approute=property/${hotelId.current}`}
      >
        <div className={styles.card_container}>
          {hotel.imagePath ? (
            <img src={hotel.imagePath} alt={hotel.name} />
          ) : (
            <img
              src="https://booking.availroom.com/v2/assets/images/noImage.jpeg"
              alt=""
            />
          )}
          <div className={styles.card_info}>
            <div className={styles.card_stars}>
              <CustomStars opinionReview={+hotel.reviews} />
            </div>
            <div className={styles.title}>{parse(hotel.name)}</div>
            <div className={styles.card_price}>
              <p className={styles.card_price_price}>{hotel.price}</p>
              <p>
                ({hotel.nights} {t("property.nights")})
              </p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MiniCard;
